import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountOpeningLoading: false,
  sendOtpLoading: false,
  verifyOtpLoading: false,
  applicationTypeDropdownLoading: false,
  applicationTypeDropdown: [],
  accountOpeningFormLoading: false,
  accountOpeningForm: {},
  submit_loading: false,
  is_nafath_verified: false,
  nafath_loading: false
}

const accountOpeningSlice = createSlice({
  name: "accountOpening",
  initialState,
  reducers: {
    setAccountOpeningLoading: (state, action) => {
      state.accountOpeningLoading = action.payload;
    },
    setSendOtpLoading: (state, action) => {
      state.sendOtpLoading = action.payload;
    },
    setVerifyOtpLoading: (state, action) => {
      state.verifyOtpLoading = action.payload
    },
    setApplicationTypeDropdownLoading: (state, action) => {
      state.applicationTypeDropdownLoading = action.payload;
    },
    setApplicationDropdown: (state, action) => {
      state.applicationTypeDropdown = action.payload
    },
    setAccountOpeingFormLoading: (state, action) => {
      state.accountOpeningFormLoading = action.payload
    },
    setAccountOpeningForm: (state, action) => {
      state.accountOpeningForm = action.payload
    },
    setSubmitLoading: (state, action) => {
      state.submit_loading = action.payload
    },
    setNafathVerified: (state, action) => {
      state.is_nafath_verified = action.payload
    },
    setNafathLoading: (state, action) => {
      state.nafath_loading = action.payload
    }
  }
});
export const { setAccountOpeningLoading, setSendOtpLoading, setOtp, setVerifyOtpLoading,
  setApplicationTypeDropdownLoading, setApplicationDropdown, setAccountOpeingFormLoading,
  setAccountOpeningForm, setSubmitLoading, setNafathVerified, setNafathLoading } = accountOpeningSlice.actions;
export default accountOpeningSlice.reducer